// eslint-disable-next-line import/prefer-default-export
export const PATH_PROJECTS = '/projects';
export const PATH_LOT_TYPE = '/lotType';
export const PATH_LOT_EDITOR = '/lot';
export const PATH_LOCATE_TYPICAL = '/locateTypical';
export const SCHEMATIC_VIEW = '/schematicView';
